import * as z from "zod";

export const getReturnOrderNotes = {
  name: "getReturnOrderNotes" as const,
  input: z.object({ returnId: z.string() }),
  output: z.array(
    z.object({ orderName: z.string(), orderNote: z.string().nullish() }),
  ),
};

export type GetReturnOrderNotesOutput = z.infer<
  typeof getReturnOrderNotes.output
>;
